export default __webpack_public_path__ + "static/media/plan-salon.543c49bd.png";